__turbopack_context__.v({
  "container": "RDZ-0G_container",
});
